// import { useState, useCallback } from "react";

// // Custom Hook for "Load More" functionality
// const useLoadMore = (initialData = [], fetchDataFn) => {
//   const [data, setData] = useState(initialData); // Holds the list of items
//   const [loading, setLoading] = useState(false); // Loading state to prevent multiple simultaneous fetches
//   const [hasMore, setHasMore] = useState(true); // To check if more data is available
//   const [page, setPage] = useState(1); // Page number or offset, depending on your API

//   // Function to load more data
//   const loadMore = useCallback(async () => {
//     if (loading || !hasMore) return; // Prevent loading if already loading or no more data

//     setLoading(true); // Set loading to true to prevent repeated calls
//     try {
//       const newData = await fetchDataFn(page); // Call the fetch function (should return new data)

//       if (newData && newData.length > 0) {
//         setData((prevData) => [...prevData, ...newData]); // Append new data to the existing list
//         setPage((prevPage) => prevPage + 1); // Increment the page number or offset
//       } else {
//         setHasMore(false); // No more data available
//       }
//     } catch (error) {
//       console.error("Error loading more data:", error);
//     } finally {
//       setLoading(false); // Reset loading state
//     }
//   }, [loading, hasMore, page, fetchDataFn]);

//   return { data, loading, hasMore, loadMore };
// };

// export default useLoadMore;

import { useState, useCallback } from "react";

const useLoadMore = (initialData = [], fetchDataFn) => {
  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);

  const loadMore = useCallback(async () => {
    if (loading || !hasMore) return;

    setLoading(true);
    try {
      const newData = await fetchDataFn(page);

      if (newData && newData.length > 0) {
        setData((prevData) => [...prevData, ...newData]);
        setPage((prevPage) => prevPage + 1);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error loading more data:", error);
    } finally {
      setLoading(false);
    }
  }, [loading, hasMore, page, fetchDataFn]);

  // 🆕 Add a reset method
  const reset = (newInitialData = [], more = true, startPage = 1) => {
    setData(newInitialData);
    setHasMore(more);
    setPage(startPage);
  };

  return { data, loading, hasMore, loadMore, reset };
};

export default useLoadMore;
